import { LEGAL_DOC_TYPES } from '@aysar/contracts';

import { type FieldDef } from '@/shared/components/dynamic-form/types/dynamic-form.types';

export type Translate = (key: string, params?: Record<string, unknown>) => string;

/**
 * A document's identity and its two switches. The key and the type are fixed
 * once created: consent records and the mobile reader both address the
 * document by them (`UpdateLegalDocumentSchema` has neither). Its position is
 * not a field either — the list is dragged into order, as the curriculum is.
 */
export function buildDocumentFields(t: Translate, isEditing: boolean): FieldDef[] {
  return [
    {
      name: 'key',
      kind: 'slug',
      label: t('document.form.key'),
      description: t('document.form.keyHint'),
      separator: '_',
      maxLength: 64,
      isRequired: true,
      isDisabled: isEditing,
      isLockedAfterCreate: true,
    },
    {
      name: 'docType',
      kind: 'select',
      label: t('document.form.docType'),
      description: t('document.form.docTypeHint'),
      isRequired: true,
      isDisabled: isEditing,
      options: LEGAL_DOC_TYPES.map((docType) => ({
        value: docType,
        label: t(`docType.${docType}`),
      })),
    },
    {
      name: 'requiresConsent',
      kind: 'switch',
      label: t('document.form.requiresConsent'),
      description: t('document.form.requiresConsentHint'),
    },
    {
      name: 'isActive',
      kind: 'switch',
      label: t('document.form.isActive'),
      description: t('document.form.isActiveHint'),
    },
  ];
}
